import { GLCreateNewPassword } from '@group-link-one/grouplink-components';

import { useNewPassword } from './useNewPassword';

export const NewPassword = () => {
  const { rewrite } = useNewPassword();

  return <GLCreateNewPassword onSubmit={rewrite} />;
};
